<footer
  role="footer"
  class="container-fluid"
>
  <p class="container">&copy; {{currentYear}} Fastr.ai</p>
</footer>
